import {
    PaginationState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from "@tanstack/react-table";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import Searchbox from "components/fields/Searchbox";
import { KycRowObj } from "..";
import moment from "moment";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import Pagination from "components/pagination";
import InfoModal from "./InfoModal";
import { toast } from "react-hot-toast";
import CustomToolTip from "components/tooltips";
import CreateKycVelocityModal from "./CreateKycVelocityModal";
import DeleteModal from "./DeleteKycVelocityModal";
import { deleteKycVelocity } from "api/graphQL_kycvelocity";

function KycTable(props:{
    tableData: any;
    fetchKycVelocity: () => void;
    onValueChange: (value: string) => void;
    roleData?: any;
    isLoading: boolean;
    page: number;
    setPage: any;
    totalpage: number;
    totalItems: number;
    currentPage: number;
    pageSize: number;
    setPageSize: any;
    clients: any[];
    filterData: () => void;
    filter: any;
    setFilter: (e: any) => void;
    setLocalFilters?: (e: any) => void;
    setClearClick: () => void;
    localFilters?: any;
}) {

    const {filter,setFilter,setClearClick,setLocalFilters,localFilters,filterData,tableData,onValueChange,isLoading,roleData,page,setPage,totalpage,totalItems,currentPage,pageSize,setPageSize,fetchKycVelocity,clients} = props;
    let defaultData = tableData;
    const [searchVal, setSearchVal] = useState<any>("");
    
    const [{ pageIndex }, setPagination] = React.useState<PaginationState>({
        pageIndex: 0,
        pageSize,
    });

    const [expandedRow, setExpandedRow] = useState<string | null>(null);

    const pagination = React.useMemo(() => ({
        pageIndex,
        pageSize,
    }), [pageIndex, pageSize],);

    const handleExpand = (rowId : any) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const handleDelete = (deleteId: string) => {
        deleteKycVelocity(deleteId)
          .then((data) => {
            fetchKycVelocity();
            toast.success(data?.message || "Record deleted");
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message ?? "Record deletion failed");
          })
          .finally(() => {
          });
    };

    const columns = [
        columnHelper.accessor("createdAt", {
            id: "createdAt",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
            ),
            cell: (info : any) => {
                const rawDate = info.getValue();
                const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
        
                return (
                    <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-1 cursor-pointer">{formattedDate}</p>
                );
            },   
        }),
        columnHelper.accessor("country", {
            id: "country",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Country</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },   
        }),
        columnHelper.accessor("transactionLimit", {
            id: "transactionLimit",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Velocity Data</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <InfoModal
                            info={info.row.original}
                            type={"request"}
                        />
                    </div>
                </>
            },   
            enableSorting:false
        }),
        columnHelper.accessor("paymentMethods", {
            id: "paymentMethods",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Payment Methods</p>
            ),
            cell: (info : any) => {
                const paymentMethodsStr = info?.row?.original?.paymentMethods;
                let paymentMethods : any = {};
                if (typeof paymentMethodsStr === "string") {
                    try {
                        paymentMethods = JSON.parse(paymentMethodsStr);
                    } catch (e) {
                    }
                } else {
                    paymentMethods = paymentMethodsStr;
                }
                const trueKeys = Object.keys(paymentMethods).filter(key => paymentMethods[key]);
                const trueCount = trueKeys.length;

                return <>
                    <div className="text-navy-700 font-bold">
                        <CustomToolTip  
                            content={
                            trueCount > 0 ? (
                                <div className="flex flex-wrap gap-2 max-w-[200px]">  
                                {trueKeys.map((meth: any, index: any) => (
                                    <span 
                                    key={index} 
                                    className="bg-gray-200 text-gray-800 capitalize px-2 py-1 rounded text-xs font-medium"
                                    >
                                    {meth.replace("_",' ')}
                                    </span>
                                ))}
                                </div>
                            ) : (
                                <span className="text-gray-500 text-xs">No Payment Methods</span>
                            )
                            }
                            trigger={trueCount}
                            header="Payment Methods"
                        />
                        </div>
                </>
            },
        }),
        columnHelper.accessor("velocityId", {
            id: "velocityId",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Action</p>
            ),
            cell: (info : any) => {
                return <>
                    <p className="flex items-center gap-3 text-sm font-bold">
                        {roleData?.[0]?.kyc_velocity?.value?.update_kyc_velocity && (
                            <CreateKycVelocityModal
                                fetchKycVelocity={fetchKycVelocity}
                                id={info.getValue()}
                                velocityId={info?.row?.original?.velocityId}
                                roleData={roleData}
                                info={false}
                                infoData={info}
                            />
                        )}
                        {roleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity_details && (
                            <CreateKycVelocityModal
                                fetchKycVelocity={fetchKycVelocity}
                                id={info.getValue()}
                                velocityId={info?.row?.original?.velocityId}
                                roleData={roleData}
                                info={true}
                                infoData={info}
                            />
                        )} 

                        {roleData?.[0]?.kyc_velocity?.value?.delete_kyc_velocity && (
                            <DeleteModal
                            fetchKycVelocity={fetchKycVelocity}
                            id={info.getValue()}
                            name={info?.row?.original?.first_name ?? ""}
                            heading={"Delete Record"}
                            infoData={info}
                            message={`This will delete the selected record , which is irreversible action. Do you still want to continue?
                        `}
                            handleDelete={handleDelete}
                            />
                        )}
                    </p>
                </>
            },   
            enableSorting:false
        }),
    ];
    const columnsNonAction = [
        columnHelper.accessor("createdAt", {
            id: "createdAt",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
            ),
            cell: (info : any) => {
                const rawDate = info.getValue();
                const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
        
                return (
                    <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-1 cursor-pointer">{formattedDate}</p>
                );
            },   
        }),
        columnHelper.accessor("country", {
            id: "country",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Country</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },   
        }),
        columnHelper.accessor("transactionLimit", {
            id: "transactionLimit",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Velocity Data</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <InfoModal
                            info={info.row.original}
                            type={"request"}
                        />
                    </div>
                </>
            },   
            enableSorting:false
        }),
        columnHelper.accessor("paymentMethods", {
            id: "paymentMethods",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Payment Methods</p>
            ),
            cell: (info : any) => {
                const paymentMethodsStr = info?.row?.original?.paymentMethods;
                let paymentMethods : any = {};
                if (typeof paymentMethodsStr === "string") {
                    try {
                        paymentMethods = JSON.parse(paymentMethodsStr);
                    } catch (e) {
                    }
                } else {
                    paymentMethods = paymentMethodsStr;
                }
                const trueKeys = Object.keys(paymentMethods).filter(key => paymentMethods[key]);
                const trueCount = trueKeys.length;

                return <>
                    <div className="text-navy-700 font-bold">
                        <CustomToolTip  
                            content={
                            trueCount > 0 ? (
                                <div className="flex flex-wrap gap-2 max-w-[200px]">  
                                {trueKeys.map((meth: any, index: any) => (
                                    <span 
                                    key={index} 
                                    className="bg-gray-200 text-gray-800 capitalize px-2 py-1 rounded text-xs font-medium"
                                    >
                                    {meth.replace("_",' ')}
                                    </span>
                                ))}
                                </div>
                            ) : (
                                <span className="text-gray-500 text-xs">No Payment Methods</span>
                            )
                            }
                            trigger={trueCount}
                            header="Payment Methods"
                        />
                        </div>
                </>
            },
        })
    ];

    const [sorting, setSorting] = React.useState<SortingState>([]);
    const [data, setData] = React.useState(() => [...defaultData]);

    useEffect(() => {    
        const processedData = tableData.map((item: any) => {
            return {
                ...item,
            };
        });
        setData(processedData);
    }, [tableData]);

    const table = useReactTable({
        data,
        columns:
            roleData?.[0]?.kyc_velocity?.value?.update_kyc_velocity ||
            roleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity_details ||
            roleData?.[0]?.kyc_velocity?.value?.delete_kyc_velocity
                ? columns
                : columnsNonAction,
        state: {
        pagination,
        sorting,
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
    });

    const handleValueChange = (e: any) => {
        onValueChange(e);
        setSearchVal(e);
    };

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-5 flex-wrap">
                <div className="block w-full justify-between gap-5 md:flex lg:flex">
                    <div className="flex items-center gap-5">
                        <div className="text-xl font-bold text-navy-700 dark:text-white">
                        KYC Velocity
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-around gap-2 md:pe-[0px] lg:pe-[0px]">
                        <Searchbox onSearch={handleValueChange} />
                    </div>
                </div>
            </header>
            <div className="mt-4  overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 relative overflow-x-auto shadow-md sm:rounded-lg">
            {props.isLoading ? (
                <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
            ) : (
                <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id} className="">
                                {headerGroup.headers.map((header) => {
                                    return (
                                        <th
                                            key={header.id}
                                            colSpan={header.colSpan}
                                            onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                            className={`border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2 ${header.column.getCanSort() ? 'cursor-pointer' : ''}`}
                                        >
                                            <div className="flex items-center text-xs text-gray-200">                                           
                                            {flexRender(header.column.columnDef.header, header.getContext())}                                    
                                            {header.column.getCanSort() && ( // Only show if sorting is enabled
                                                <span className="ml-2">
                                                {header.column.getIsSorted() === "asc" ? (
                                                    <BsArrowUp size={14} className="text-gray-900" />
                                                ) : header.column.getIsSorted() === "desc" ? (
                                                    <BsArrowDown size={14} className="text-gray-900" />
                                                ) : (
                                                    <RiArrowUpDownFill size={14} className="text-gray-900" />
                                                )}
                                                </span>
                                            )}
                                            </div>
                                        </th>
                                    )
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody >
                    {(table.getRowModel().rows?.length > 0) ? table.getRowModel().rows.map((row) => {
                        return (
                            <React.Fragment key={row.id}>
                                <tr key={row.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                    {row.getVisibleCells().map((cell) => {
                                        return (
                                        <td
                                            key={cell.id}
                                            className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900"
                                        >
                                            {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                            )}
                                        </td>
                                        );
                                    })}
                                </tr>
                            </React.Fragment>
                        )
                    }) :
                        <tr>
                            <td colSpan={5} >
                            <p className="text-center p-4" >No records found.</p>
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            )}
            </div>
            <Pagination
                setPage={setPage}
                page={page}
                totalpage={totalpage}
                currentPage={currentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                arraySize={[50, 100, 200]}
            />
        </Card>
    );
}
export default KycTable;
const columnHelper = createColumnHelper<KycRowObj>();
